<template lang="pug">
.label-text(v-if="section.description", style="margin-left:26px")
    WithRequired(:required="false",:text="section.description",:cut_text="true")
</template>
<script>
import WithRequired from "../shared/_with_required";

export default {
  props: ['section'],
  components: {WithRequired}
}
</script>